import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {ConstantService} from "../../services/constant.service";


@Injectable()
export class CrudService extends ConstantService {

  headers: HttpHeaders;
  mediaHeaders: HttpHeaders;

  constructor(private readonly http: HttpClient, private readonly _constantService: ConstantService) {
    super();
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.mediaHeaders = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    });
  }

  public get(api: string, query?: HttpParams) {
    return this.http.get<any>(this._constantService.API_ENDPOINT + api, {
      headers: this.headers,
      params: query
    });
  }

  public getOne(api: string, id: any, query?: HttpParams) {
    return this.http.get<any>(this._constantService.API_ENDPOINT + api + '/' + id, {
      headers: this.headers,
      params: query
    });
  }

  public post(api: string, data: any, query?: HttpParams) {
    return this.http.post<any>(this._constantService.API_ENDPOINT + api, data, {
      headers: this.headers,
      params: query
    });
  }

  public postMedia(api: string, data: any) {
    return this.http.post<any>(this._constantService.API_ENDPOINT + api, data);
  }

  public put(api: string, id: string, data: any, query?: HttpParams, apiSuffix?: string, ) {
    return this.http.put<any>(this._constantService.API_ENDPOINT + api + '/' + id + (apiSuffix ? ("/" + apiSuffix) : ""), data, {
      headers: this.headers,
      params: query
    });
  }

  public patch(api: string, id: string, apiSuffix: string, data: any, query?: HttpParams) {
    return this.http.patch<any>(
      this._constantService.API_ENDPOINT + api + '/' + id + (apiSuffix ? '/' + apiSuffix : ''),
      data,
      { headers: this.headers, params: query }
    );
  }

  public putMedia(api: string, id: string, data: any) {
    return this.http.put<any>(this._constantService.API_ENDPOINT + api + '/' + id, data);
  }

  public delete(api: string, id: string, query?: HttpParams) {
    return this.http.delete<any>(this._constantService.API_ENDPOINT + api + '/' + id, {
      headers: this.headers,
      params: query
    });
  }



  public authPost(api: string, data: any, query?: HttpParams) {
    return this.http.post<any>(this._constantService.ADMIN_AUTH_ENDPOINT + api, data, {
      headers: this.headers,
      params: query
    });
  }

}
